<template>
  <nav class="menu-container">
   <h3> <!-- <font color="#00AB39">E3路</font>-->71路<br>深圳71路公交车路线[常规线路]</h3> 
运行时间：公交大厦总站06:30-21:30 |<br>
东海城市广场公交首末站06:30-21:30<br>
参考票价：一票制2元<br>
公交公司：深圳巴士集团股份有限公司<br>

<br><br>
深圳71路公交车路线
<br>
公交大厦总站—农科中心<br>


<ol>
<li>公交大厦总站</li>
<li>公交大厦</li>
<li>彩田村(1)</li>
<li>莲花北村(1)</li>
<li>北大医院(1)</li>
<li>莲花山西(2)</li>
<li>莲花山公园</li>
<li>儿童医院</li>
<li>市民中心西</li>
<li>信息枢纽大厦</li>
<li>益田中路</li>
<li>东方雅苑</li>
<li>皇岗公园</li>
<li>益田村</li>
<li>市妇幼保健院福强院区</li>
<li>新洲村</li>
<li>沙尾</li>
<li>上沙村(2)</li>
<li>天安数码城</li>
<li>香蜜红荔立交</li>
<li>东海花园</li>
<li>深圳风湿病医院</li>
<li>高级中学南校区</li>
<li>东海城市广场公交首末站</li>
</ol>

<br><br>
农科中心—公交大厦总站
<br>

<ol>
<li>东海城市广场公交首末站</li>
<li>东海实验小学</li>
<li>高级中学南校区</li>
<li>深圳风湿病医院</li>
<li>东海花园</li>
<li>香蜜红荔立交</li>
<li>天安数码城</li>
<li>上沙村</li>
<li>沙尾</li>
<li>新洲村</li>
<li>市妇幼保健院福强院区</li>
<li>益田村</li>
<li>皇岗公园</li>
<li>东方雅苑</li>
<li>益田中路</li>
<li>信息枢纽大厦</li>
<li>市民中心西</li>
<li>儿童医院</li>
<li>莲花山公园(1)</li>
<li>莲花山西(2)</li>
<li>商报社</li>
<li>北大医院(1)</li>
<li>莲花北村(1)</li>
<li>彩田村(1)</li>
<li>公交大厦总站</li>
</ol>

   <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
  </nav>
</template>

<script>
import Icon from "@/components/Icon";
export default {
  components: {
    Icon,
  },
  data() {
    return {
      items: [
        // 模板         {
        //  name: "azhan",
        //  title: "A站",
        //  icon: "chat",
        //  exact: true,
        //  },

        // {
        //   name: "",
        //    title: "",
        //   // icon: "chat",
        //   exact: true,
        // },
        // {
        //   name: "",
        //    title: "",
        //   // icon: "chat",
        //   exact: true,
        // },
        // {
        //   name: "",
        //    title: "",
        //   // icon: "chat",
        //   exact: true,
        // },
        // {
        //   name: "",
        //    title: "",
        //   // icon: "chat",
        //   exact: true,
        // },
        // {
        //   name: "",
        //    title: "",
        //   // icon: "chat",
        //   exact: true,
        // },
        // {
        //   name: "",
        //    title: "",
        //   // icon: "chat",
        //   exact: true,
        // },
        // {
        //   name: "",
        //    title: "",
        //   // icon: "chat",
        //   exact: true,
        // },
        // {
        //   name: "",
        //    title: "",
        //   // icon: "chat",
        //   exact: true,
        // },
        // {
        //   name: "",
        //    title: "",
        //   // icon: "chat",
        //   exact: true,
        // },
        // {
        //   name: "",
        //    title: "",
        //   // icon: "chat",
        //   exact: true,
        // },
        // {
        //   name: "",
        //    title: "",
        //   // icon: "chat",
        //   exact: true,
        // },
        // {
        //   name: "",
        //    title: "",
        //   // icon: "chat",
        //   exact: true,
        // },
        // {
        //   name: "",
        //    title: "",
        //   // icon: "chat",
        //   exact: true,
        // },
        // {
        //   name: "",
        //    title: "",
        //   // icon: "chat",
        //   exact: true,
        // },
        // {
        //   name: "",
        //    title: "",
        //   // icon: "chat",
        //   exact: true,
        // },
        // {
        //   name: "",
        //    title: "",
        //   // icon: "chat",
        //   exact: true,
        // },
        // {
        //   name: "",
        //    title: "",
        //   // icon: "chat",
        //   exact: true,
        // },
        // {
        //   name: "",
        //    title: "",
        //   // icon: "chat",
        //   exact: true,
        // },
        // {
        //   name: "",
        //    title: "",
        //   // icon: "chat",
        //   exact: true,
        // },
        // {
        //   name: "",
        //    title: "",
        //   // icon: "chat",
        //   exact: true,
        // },
        // {
        //   name: "",
        //    title: "",
        //   // icon: "chat",
        //   exact: true,
        // },
        // {
        //   name: "",
        //    title: "",
        //   // icon: "chat",
        //   exact: true,
        // },
        // {
        //   name: "",
        //    title: "",
        //   // icon: "chat",
        //   exact: true,
        // },
        // {
        //   name: "",
        //    title: "",
        //   // icon: "chat",
        //   exact: true,
        // },
        // {
        //   name: "",
        //    title: "",
        //   // icon: "chat",
        //   exact: true,
        // },
        // {
        //   name: "",
        //    title: "",
        //   // icon: "chat",
        //   exact: true,
        // },
        // {
        //   name: "",
        //    title: "",
        //   // icon: "chat",
        //   exact: true,
        // },
        // {
        //   name: "",
        //    title: "",
        //   // icon: "chat",
        //   exact: true,
        // },
        // {
        //   name: "",
        //    title: "",
        //   // icon: "chat",
        //   exact: true,
        // },
        // {
        //   name: "",
        //    title: "",
        //   // icon: "chat",
        //   exact: true,
        // },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(67, 47, 221);
    }
  }
}
//ol 列表数字改为圆圈  
ol {
counter-reset: section;
list-style: none;
}

li {
margin: 0 0 10px 0;
line-height: 25px;
}

li:before {
content: counter(section);
counter-increment: section;
display: inline-block;
width: 25px;
height: 25px;
margin: 0 10px 0 0;
border: 1px solid #228B22;  //绿色，同左边主导航一样颜色 #228B22
border-radius: 100%;
text-align: center;
}
</style>





